import BaseRepository from "@/services/resources/repository";
import byEvent from "@/services/resources/mixins/query-by-event";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(byEvent);
    }
}

export default Repository;
